'use strict';

const REG_TYPE = require('../../../../../constant').REG_TYPE;

const SIGN_TYPE = {
    0x00: 'UNSIGNED',
    0x01: 'SIGNED'
};

function parse(reader) {
    reader.readUInt8('data.params.rule_index');
    reader.readUInt8('data.params.enable');
    reader.readUInt8('data.params.slave_id');
    reader.readUInt8('data.params.quantity');
    reader.readUInt8('data.params.register_type', value => REG_TYPE[value]);
    reader.readUInt8('data.params.sign_type', value => SIGN_TYPE[value]);
    reader.readUInt8('data.params.decimal');
    reader.readUInt16LE('data.params.address');
    reader.readString(16, 'data.params.channel_name');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/uart-channel-parser.js